import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CyberSOCPage from "../pages/cybersoc/page";
import ServiceDeskPage from "../pages/servicedesk/page";
import DatacenterPage from "../pages/datacenter/page";
import ConsultoriaPage from "../pages/consultoria/page";
import ContactanosPage from "../pages/contactanos/page";
import PoliticaPrivacidadPage from "../pages/politica-privacidad/page";
import TerminosPage from "../pages/terminos/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cybersoc",
    element: <CyberSOCPage />,
  },
  {
    path: "/service-desk",
    element: <ServiceDeskPage />,
  },
  {
    path: "/datacenter",
    element: <DatacenterPage />,
  },
  {
    path: "/consultoria",
    element: <ConsultoriaPage />,
  },
  {
    path: "/contactanos",
    element: <ContactanosPage />,
  },
  {
    path: "/politica-privacidad",
    element: <PoliticaPrivacidadPage />,
  },
  {
    path: "/terminos",
    element: <TerminosPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;